import React,{Component} from 'react';
import { HashRouter  as Router, Route } from 'react-router-dom'
import { connect } from 'react-redux';

import {AuthRoute} from './AuthRoute';
import publicAccessContainer from './publicAccess/publicAccessContainer';
import Login from './login/Login';
import createAccount from './login/createAccount';
import forgotPassword from './login/forgotPassword';
import emailSent from './login/emailSent';
import resetPassword from './login/resetPassword';
import confirmationScreen from './login/confirmationScreen';
import {Footer} from './publicAccess/footer/Footer';
import { Loader } from './ui/Loader';
import Notification from './ui/Notification';

class App extends Component {
	render(){
		return (
			<div className={`display-unset ${this.props.loading}`}>
				<div id="wrap" className="row">
					<Router>
						<div>
							<AuthRoute exact path="/" component={publicAccessContainer} />
							<AuthRoute path="/publicAccess" component={publicAccessContainer} />
							<Route path="/login/:caseid?/:eCourtUserId?/:tablename?" component={Login} />
							<Route path="/createaccount/:caseid?/:eCourtUserId?/:tablename?" component={createAccount} />
							<Route path="/forgotPassword" component={forgotPassword} />
							<Route path="/emailSent" component={emailSent} />
							<Route path="/confirmationScreen" component={confirmationScreen} />
							<Route path="/resetPassword/:userId/:currentTime" component={resetPassword} />
						</div>
					</Router>
				</div>
				<Footer/>
				<Loader/>
				<Notification/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {loading:state.uiState.loader?'loading':''};
}
export default connect(mapStateToProps, null)(App);